import { React, useLayoutEffect } from "react";
import styled from "styled-components";
import {
  ContentArea,
  InPersonSessionImage,
  IntroArea,
  IntroTextContainer,
  SessionImageContainer,
  SessionPageContainer,
  SubTitle,
} from "../components/SessionPageComponents";
import MentoringImage from "../assets/gallery/2.jpeg";
import { SectionTitle } from "../components/SectionTitle";
import {
  ContactSubTitle,
  TextContainer,
  AllSocialsContainer,
  StyledLink,
  SocialContainer,
} from "../sections/ContactSection";
import { SiProtonmail } from "react-icons/si";

export const MentoringPage = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SessionPageContainer>
      <ContentArea>
        <SectionTitle title="Mentoring" />
        <br />
        <IntroArea>
          <SessionImageContainer>
            <InPersonSessionImage image={MentoringImage} />
          </SessionImageContainer>
          <IntroTextContainer>
            Power is a language. Most people speak it without knowing it —
            stumbling through dynamics they never chose, in rooms they don't
            know how to read. I have spent the last decade learning it
            deliberately. And occasionally, I teach it.Mentoring sessions with
            me are not a course, a workshop, or a consultation. They are a
            conversation between someone who has lived inside these dynamics —
            professionally, academically, personally — and someone ready to go
            deeper into their own understanding of power.
            <br />
            <SubTitle>Who this is for</SubTitle>
            You might be a Dominant finding your footing, a couple trying to
            bring power exchange into your relationship without breaking it, a
            Pro Domme navigating the less glamorous realities of the work, or
            simply someone at a crossroads in their journey with no one
            qualified to talk to. If you are serious about learning, and honest
            about where you are — we can work together.
          </IntroTextContainer>
        </IntroArea>
        <br />

        <br />
        <br />
        <SubTitle>What we can explore</SubTitle>
        <TextContainer>
          <TopicTitle>Scene</TopicTitle>
          <ul>
            <li>Non-verbal communication for Dominance</li>
            <li>
              Safety, technique and grace on: flogging, bondage, foot play etc
            </li>
            <li>Becoming a better Top: techniques and human connection</li>
            <li>Consent in practice</li>
            <li>Trauma & BDSM</li>
          </ul>
          <TopicTitle>Work</TopicTitle>
          <ul>
            <li>FemDom as leverage for workplace empowerment</li>
            <li>
              Verbal communication for Dominance in difficult
              professionalconversations
            </li>
            <li>Becoming a Pro Domme: challenges and opportunities</li>
            <li>
              Privacy, data, payment systems and digital challenges for Pro
              Dommes
            </li>
            <li>Power dynamics in negotiations</li>
          </ul>
          <TopicTitle>Love & Intimacy</TopicTitle>
          <ul>
            <li>Navigating Kink inside love relationships</li>
            <li>Navigating love inside BDSM dynamics</li>
            <li>Kink and polyamory</li>
          </ul>
        </TextContainer>
        <br />
        <br />
        <SubTitle>How it works</SubTitle>
        <TextContainer>
          Reach out and tell me a little about yourself and what you want to
          explore. From there, we find a format that fits — online or in person,
          solo or with a partner.
          <br />
          <br />
          If the session includes practical elements, you provide the space. If
          it is a conversation, we can meet somewhere quiet. You may bring a
          submissive as a demonstration partner if the session calls for it — or
          let me know and we can arrange one.
          <br />
          <br />
          Everything discussed stays between us. Complete discretion, always.
        </TextContainer>
        <br />
        <br />
        <SubTitle>What I bring</SubTitle>
        <TextContainer>
          Over a decade of experience in Professional FemDom, built from the
          ground up across two continents. An academic research thesis on Power
          Dynamics and Society. A career navigated in male-dominated
          professional environments. First-hand experience in BDSM within love
          relationships and polyamory. A trauma-informed, LGBT+ inclusive
          approach. Couples, throuples, and polycules are welcome.
        </TextContainer>
        <br />
        <br />
        <SubTitle>What this is not</SubTitle>
        <TextContainer>
          We will not be in a D/s dynamic. I am not your Mistress in these
          sessions — I am your mentor. Do not expect latex. Do not expect me to
          have all your answers. Do expect honesty, precision, and the kind of
          perspective that only comes from someone who has actually lived this.
          <br />
          <br />I am not a licensed therapist. These sessions are not a
          substitute for professional mental health support.
        </TextContainer>

        <br />
        <br />
        <SubTitle>Contact</SubTitle>
        <TextContainer>
          <ContactSubTitle>
            If this resonates, reach out. Tell me a little about yourself, what
            brings you here, and what you'd like to explore. That's all I need
            to get us started.
          </ContactSubTitle>

          <AllSocialsContainer>
            <StyledLink href="mailto:mayamistress@protonmail.com">
              <SocialContainer>
                <SiProtonmail className="social-icon" />
                Contact me via Email
              </SocialContainer>
            </StyledLink>
          </AllSocialsContainer>
          <br />
          <br />
        </TextContainer>
      </ContentArea>
    </SessionPageContainer>
  );
};

const TopicTitle = styled.h3`
  font-family: "Ysabeau", sans-serif;
  font-style: italic;
  font-weight: 300;
  font-size: 22px;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 0.25rem;
  margin-top: 1.5rem;
`;
